//客户中心
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'

export default {
  '/customer/agent/getCustomersList': mockBaseUrl + '/customer/agent/getCustomersList',
  '/customer/agent/updateCustomerInfo': mockBaseUrl + '/customer/agent/updateCustomerInfo',
  '/customer/agent/getAgentCustomerInfo': mockBaseUrl + '/customer/agent/getAgentCustomerInfo',
  '/customer/agent/deleteCustomerInfo': mockBaseUrl + '/customer/agent/deleteCustomerInfo'
}
